import axios from 'lib/axios'

export interface InventoryCompany {
  id: number
  name: string
}

export interface ManagedInventory {
  id: number
  subscriptionName: string
  name: string
  companyId: number
  companyName: string
  credits: number
  usedCredits: number
  creditsAvailable: number
  subscriptionId: number
  start_date: string
  expiration_date: string
  state: boolean
  isUnlimited: boolean
}

interface InventoryCompaniesResponse {
  status: 'OK'
  data: InventoryCompany[]
  internal: boolean
}

interface ManagedInventoriesResponse {
  status: 'OK'
  data: ManagedInventory[]
  total_results: number
  total_pages: number
}

export const getInventoryCompanies = async (): Promise<InventoryCompaniesResponse> => {
  const response = await axios.get<InventoryCompaniesResponse>('/inventory/management/companies')
  return response.data
}

export const getManagedInventories = async (
  companyId: number | null,
  page: number,
  limit: number,
): Promise<ManagedInventoriesResponse> => {
  const response = await axios.get<ManagedInventoriesResponse>('/inventory/management', {
    params: { company_id: companyId || undefined, page, limit },
  })
  return response.data
}
